/* tslint:disable:max-line-length */
import {FuseNavigationItem} from "fuseui";

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Přehled',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/dashboard',
        role: 'other',
    },
    {
        id: 'users',
        title: 'Uživatelé',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/users',
        role: 'other',
    },
    {
        id: 'parts',
        title: 'Materiál',
        type: 'basic',
        icon: 'heroicons_outline:cube',
        link: '/parts',
        role: 'other',
    },
    {
        id: 'warehouses',
        title: 'Sklady',
        type: 'basic',
        icon: 'heroicons_outline:office-building',
        link: '/warehouses',
        role: 'other',
    },
    {
        id: 'transactions',
        title: 'Transakce',
        type: 'basic',
        icon: 'heroicons_outline:switch-horizontal',
        link: '/transactions',
        role: 'other',
    },
    {
        id: 'warehouse-status',
        title: 'Stav skladu',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-list',
        link: '/warehouse-status',
        role: 'other',
    },
    {
        id: 'app-group',
        title: 'Číselníky',
        subtitle: 'Číselníky pro správu',
        type: 'group',
        children: []
    },
    {
        id: 'app-group',
        title: 'Aplikace ABC Pack',
        subtitle: 'Vše co potřebujete vědět',
        type: 'group',
        children: [
            {
                id: 'support',
                title: 'Podpora',
                type: 'basic',
                icon: 'heroicons_outline:question-mark-circle',
                link: '/support'
            },
            {
                id: 'changelog',
                title: 'Changelog',
                type: 'basic',
                icon: 'heroicons_outline:newspaper',
                link: '/changelog'
            }
        ]
    },
];

export const defaultNavigationNotAdmin: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Přehled',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/dashboard',
        role: 'other',
    },
    {
        id: 'parts',
        title: 'Materiál',
        type: 'basic',
        icon: 'heroicons_outline:cube',
        link: '/parts',
        role: 'other',
    },
    {
        id: 'transactions',
        title: 'Transakce',
        type: 'basic',
        icon: 'heroicons_outline:switch-horizontal',
        link: '/transactions',
        role: 'other',
    },
    {
        id: 'warehouse-status',
        title: 'Stav skladu',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-list',
        link: '/warehouse-status',
        role: 'other',
    },
    {
        id: 'app-group',
        title: 'Aplikace ABC Pack',
        subtitle: 'Vše co potřebujete vědět',
        type: 'group',
        children: [
            {
                id: 'support',
                title: 'Podpora',
                type: 'basic',
                icon: 'heroicons_outline:question-mark-circle',
                link: '/support'
            },
            {
                id: 'changelog',
                title: 'Changelog',
                type: 'basic',
                icon: 'heroicons_outline:newspaper',
                link: '/changelog'
            }
        ]
    },
];

export const compactNavigation: FuseNavigationItem[] = [];
export const futuristicNavigation: FuseNavigationItem[] = [];
export const horizontalNavigation: FuseNavigationItem[] = [];
export const horizontalNavigationNotAdmin: FuseNavigationItem[] = [];
